/*import 'core-js/es6/map';
import 'core-js/es6/set';
import 'core-js/es6/symbol';
import 'core-js/es6/object';
import 'core-js/es6/function';
import 'core-js/es6/parse-int';
import 'core-js/es6/parse-float';
import 'core-js/es6/number';
import 'core-js/es6/math';
import 'core-js/es6/string';
import 'core-js/es6/date';
import 'core-js/es6/array';
import 'core-js/es6/regexp';
import 'core-js/es6/weak-map';*/

import React from 'react';
import { createRoot } from 'react-dom/client';
import './css/grid-layout.css';
import './css/grid-resizable.css'
import './css/bootstrap.css'
import MainScreen from './mainScreen';
import Root from './Root';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import { CookiesProvider } from 'react-cookie';
import 'webrtc-adapter';
//var Chat = require('./Chat');
 //<Root/>
 /*
 <Router basename={'/outside-broadvcast'}>
			<Route path="/" component={Root} />
			
		</Router>
		*/
createRoot(document.getElementById('app')).render(
	<Router basename={'/'}>
		<Route path="/:token?" component={Root} />
	</Router>
);

